'use strict';

import Hammer from 'hammerjs';
import Crop from 'crop';
import template from './crop.html';

const minCropSize = [300, 300];
const defaultSlaceFactor = 0.05;

function controller($scope, $window, $element, photoModel, keyCodes) {
  'ngInject';

  var documentEl = angular.element($window.document);
  var photo = this.photo;
  var crop = photo.crop;

  function keyupHandler(event) {
    $scope.$apply(() => {
      if (event.which === keyCodes.ESC && !$scope.ctrl.crop.isLoading) {
        $scope.ctrl.done();
        event.stopImmediatePropagation();
      }
    });
  }

  this.save = function () {
    var cropCoords;
    var cropData;

    if (this.isLoading) {
      return;
    }

    cropCoords = this.crop.getCoords();
    cropData = {
      x1: cropCoords[0][0],
      y1: cropCoords[0][1],
      x2: cropCoords[1][0],
      y2: cropCoords[1][1]
    };

    this.isLoading = true;

    photoModel.cropPhoto(photo, cropData)
      .then(() => this.done())
      .finally(() => delete this.isLoading);
  };

  this.cancel = function () {
    this.done();
  };

  this.crop = new Crop($element[0].querySelector('.Crop-zone'), {
    minSize: minCropSize,
    coords: [[crop.x1, crop.y1], [crop.x2, crop.y2]],
    transform: {
      realSize: [photo.width, photo.height]
    }
  });

  /**
   * Zooms photo inside crop box in.
   */
  this.zoomIn = function (scaleFactor) {
    var scaleValue = 1 + (Number(scaleFactor) || defaultSlaceFactor);

    this.crop.scaleImage(scaleValue);
  };

  /**
   * Zooms photo inside crop box out.
   */
  this.zoomOut = function (scaleFactor) {
    var scaleValue = 1 - (Number(scaleFactor) || defaultSlaceFactor);

    this.crop.scaleImage(scaleValue);
  };

  documentEl.on('keyup', keyupHandler);
  $element.on('$destroy', () => {
    this.crop.destroy();
    documentEl.off('keyup', keyupHandler);
  });
}

export default function f() {
  return {
    template: template,
    require: 'saCrop',
    replace: true,
    scope: {
      photo: '=',
      done: '&'
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: controller,
    link: function ($scope, $element, $attr, saCropCtrl) {
      var eventManager = new Hammer($element[0].querySelector('.Crop-zone'), {
        recognizers: [
          [Hammer.Pinch, { enable: true }]
        ]
      });

      eventManager.on('pinchin', () => {
        $scope.$apply(() => saCropCtrl.zoomIn());
      });

      eventManager.on('pinchout', () => {
        $scope.$apply(() => saCropCtrl.zoomOut());
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/directives/crop.js